import { render, staticRenderFns } from "./VuesticCard.vue?vue&type=template&id=664bd6d0"
import script from "./VuesticCard.vue?vue&type=script&lang=js"
export * from "./VuesticCard.vue?vue&type=script&lang=js"
import style0 from "./VuesticCard.vue?vue&type=style&index=0&id=664bd6d0&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pagsmile/front-end/pagsmile-dashboard/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('664bd6d0')) {
      api.createRecord('664bd6d0', component.options)
    } else {
      api.reload('664bd6d0', component.options)
    }
    module.hot.accept("./VuesticCard.vue?vue&type=template&id=664bd6d0", function () {
      api.rerender('664bd6d0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/vuestic-theme/vuestic-components/vuestic-card/VuesticCard.vue"
export default component.exports